import { flowWithSafeComponent } from '@atlassian/jira-issue-view-common-utils/src/flow-with-safe-component/index.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import { getTitle, getChildTitle } from '../../../state/context/selectors.tsx';
import type { State } from '../../../state/types.tsx';
import { Title } from './view.tsx';

export default flowWithSafeComponent(
	connect(
		(state: State) => ({
			title: getTitle(state),
			titleChildIssues: getChildTitle(state),
		}),
		{},
	),
)(Title);
